// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"036c4798","232":"7006428c","453":"02979aa2","466":"aa88b69c","507":"c7b9b95d","599":"237746bd","616":"c53f64e2","772":"48045380","780":"49853083","914":"71de0546","923":"f37e45cc"}[chunkId] + ".chunk.js";
};